import { PageHero } from "../components/site/PageHero";
import { Reviews, LicenseBanner } from "../components/site/Trust";
import { CTABand } from "../components/site/CTABand";

export default function ReviewsPage() {
  return (
    <>
      <PageHero
        eyebrow="Customer Reviews"
        title="Trusted by our customers."
        subtitle="Real feedback from the homeowners and businesses we serve."
      />
      <Reviews />
      <LicenseBanner />
      <CTABand />
    </>
  );
}
